import { UPC_VALIDATION_MESSAGES } from '~/modules/upc/consts/validation';

/**
 * * Gift card amount validator
 */
export const giftCardAmount = (value?: string | null): string | boolean => {
  if (value === null || value === undefined || value === '') {
    return UPC_VALIDATION_MESSAGES.VALUE_NOT_SELECTED;
  }
  return true;
};
